import { visit } from "unist-util-visit";

// Minimal mdast-like node shape for the nodes this plugin touches (mdast type packages
// aren't installed in this app), narrowed via casts inside the visitor below.
interface MarkdownNode {
  type: string;
  value?: string;
  children?: MarkdownNode[];
}

export const remarkVimeo = () => {
  return (tree: MarkdownNode) => {
    visit(tree, "paragraph", (node, index, parent) => {
      const paragraph = node as MarkdownNode;
      const parentNode = parent as MarkdownNode | undefined;
      if (!parentNode || !index) return;

      const textNode = paragraph.children?.[0];
      if (!textNode || textNode.type !== "text") return;

      const match = textNode.value?.match(/^!vimeo\[(\d+)]$/);
      if (match) {
        const videoId = match[1];

        if (parentNode.children) {
          parentNode.children[index] = {
            type: "html",
            value: `
            <div style="position: relative; width: 100%; padding-bottom: 56.25%; height: 0; overflow: hidden;">
              <iframe
                src="https://player.vimeo.com/video/${videoId}"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen>
              </iframe>
            </div>
          `.trim(),
          };
        }
      }
    });
  };
};
